import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import ApiService from '../service/ApiService';
import { withRouter } from '../ganchos/withRouter';
import { toast } from 'react-toastify';
import IconeHay from "../images/logo-loading.png";
import lodash from "lodash";
import utilService from '../service/UtilService';
import { Link } from 'react-router-dom';
import Modal from '../components/ui/modal';

class SelecionarContrato extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fidelidadeExpirandoVisivel: false,
            telefones: []
        }
    }

    async consultarNumerosContrato(){
        this.setState({ fidelidadeExpirandoVisivel: false });
        const retorno = await ApiService.verificarNumerosAutoAtendimento({
            idcontrato: this.props.contrato.contratoid,
        });
        switch (retorno?.state) {
            case "menu.mensagem.telefones.encontrados.para.contrato":
                this.setState({ escolherNumeroVisivel: true, telefones: retorno.telefones });
            break;
            case "menu.mensagem.nenhum.telefone.encontrado.neste.contrato":
            default:
                toast.error("Nenhum telefone foi encontrado neste contrato. Contate a nossa central de atendimento.",{
                    autoClose: false,
                    position: "bottom-center",
                    theme: "colored",
                    closeOnClick: true,
                });
        }
    }
    
    async selecionarTelefone(telefone){
        const iniciarAtendimento = await ApiService.iniciarAtendimento({
            telefone: telefone.identificacao,
            idOperacaoTotem: this.props.operacaoTotem.id,
            idclientecontrato: this.props.contrato.contratoid,
        });
        toast.success("Em instantes chamaremos você no whatsapp através do telefone escolhido.");
        
        this.setState({ escolherNumeroVisivel: false });
    }

    async verificarFidelidade(contrato){
        if (this.props.operacaoTotem.mensagemRefidelizacao){
            const validarFidelidade = await ApiService.buscarFidelidadePorContrato({ idcontrato: contrato.contratoid });
            if (validarFidelidade.expirando){
                return this.setState({ fidelidadeExpirandoVisivel: true, contrato: contrato });
            } 
        }
        this.selecionarContrato(contrato);
    }

    async selecionarContrato(contrato) {       
        const faturas = await ApiService.buscarFaturasPorContrato({ idcontrato: contrato.contratoid }) || [];
        this.props.onSuccess && this.props.onSuccess({ ...contrato, ...faturas });
        utilService.iniciarTimerSessao(this.props.aoExpirar, toast);
        switch(this.props.operacaoTotem?.redirecionar){
            default:
            case "main.operacaototem.redirecionar.faturas": 
                return this.props.navigate("/contratoselecionado/"+ this.props.operacaoTotem.id);
            case "main.operacaototem.redirecionar.menuinicial":
                return this.props.navigate("/menuinicial/"+ this.props.operacaoTotem.id);
        }
    }

    async aoFecharFidelidade(){
        this.setState({ fidelidadeExpirandoVisivel: false });
        this.selecionarContrato(this.state.contrato);
    }

    formatarNome() {
        return lodash.truncate(lodash.first(this.props.contratos)?.nomeassinante || "Fulano da Silva", { length: 35 });
    }

    formatarCpf() {
        return utilService.formatCpfCnpj(lodash.first(this.props.contratos)?.cpfCnpj || "11122233344");
    }

    aoFecharTelefone(){
        this.setState({ escolherNumeroVisivel: false })
        this.selecionarContrato(this.state.contrato);
    }
    async componentDidMount(){
        if (this.props.contrato){
            await this.verificarFidelidade(this.props.contrato);
        }
    }
    

    render() {
        return (
            <>
                <ul id="progress-bar" className="entry-bookend-progress-container header fundo-contratos">
                    <div className="topo-navegacao">
                        <img alt="Logo da Hay Systems" src={this.props.operacaoTotem.logoPrincipalAutoAtendimento || IconeHay} className={"img-topo-navegacao"} />
                        <p className="nome-usuario-navegacao">{this.formatarNome()}</p>
                        <p className="cpf-usuario-navegacao">{this.formatarCpf()} </p>
                    </div>
                    <ul className="entry-bookend-progress-container header breadcrumb" >
                        <li className="progress-item progress-step" >
                            <span className="circle progress-index numero numero-breadcrumb" >
                                <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                    <FontAwesomeIcon className={"fa-fw index unselectable circulo-breadcrumb"} size="3x" icon={"circle"} />
                                    <span class="fa-layers-text fa-1x unselectable" style={{ fontWeight: 900, color: "white" }}>  </span>
                                </span>
                            </span>
                        </li>
                        <p className="texto-breadcrumb">Identificação</p>
                        <FontAwesomeIcon className='fa-fw icone-resultado chevron-breadcrumb' size="s"  icon={"chevron-right"} />
                        <li className="progress-item progress-step" >
                            <span className="circle progress-index numero numero-breadcrumb" >
                                <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                    <FontAwesomeIcon className={"fa-fw index unselectable circulo-breadcrumb"} size="3x" icon={"circle"} />
                                    <span class="fa-layers-text fa-1x unselectable" style={{ fontWeight: 900, color: "white"  }}>  </span>
                                </span>
                            </span>
                        </li>
                        <p className="texto-breadcrumb">Contrato</p>
                        <FontAwesomeIcon className='fa-fw icone-resultado chevron-breadcrumb' size="s"  icon={"chevron-right"} />
                        <li className="progress-item progress-step apagadim">
                            <span className="circle progress-index numero numero-breadcrumb" >
                                <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                    <FontAwesomeIcon className={"fa-fw index unselectable circulo-breadcrumb"} size="3x" icon={"circle"} />
                                    <span class="fa-layers-text fa-1x unselectable" style={{ fontWeight: 900, color: "white"  }}>  </span>
                                </span>
                            </span>
                        </li>
                        <p className="texto-breadcrumb apagadim">Faturas</p>
                        
                        
                        <li className="progress-item progress-step" >
                            <span className="circle progress-index numero numero-breadcrumb" >
                                <Link to={this.props.contrato?.contratoid ? "/menuinicial/" + this.props.operacaoTotem.id : '#'} >
                                        <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                            <FontAwesomeIcon className={"fa-fw index unselectable circulo-breadcrumb"} size="3x" icon={"circle"} style={{ color: "lime" }} />
                                            <FontAwesomeIcon className={"fa-fw index unselectable"} size="" icon={"home"} />
                                        </span>
                                </Link>
                            </span>
                        </li>
                    </ul>

                    <span className="entry-bookend-progress-container header" style={{
                        paddingBottom: 0,
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        width: "70%",
                        fontSize: "xx-large",
                        fontWeight: 900,
                        position: 'fixed',
                        bottom: 0
                    }}>

                        <p className="selecao-contrato"> Selecione o seu contrato: </p>

                        <ul id="progress-bar" className="entry-bookend-progress-container header lista-contratos" style={{height: 450, overflowY: "auto", alignItems:'flex-start'}}>
                            
                            {/* <span className="entry-bookend-progress-container header interior" >
                                <div style={{width: "90%"}}>
                                    <p className="nome-cliente">Heitor Ribeiro Trevisan </p>
                                    <p className="endereco-cliente">Rua Doutor João Antiqueira Elias 07 </p>
                                    <p className="endereco-cliente">Jardim Universitário - Marília</p>
                                    <p className=""></p>
                                    <p className="labels">
                                        <span className="label-contrato">Contrato: 160504</span>
                                        <span className="label-situacao">Atrasada</span>
                                    </p>
                                    
                                </div>
                                <a className="botao-contrato">
                                    <FontAwesomeIcon className='fa-fw icone-resultado' size="lg"  icon={"chevron-right"} />
                                </a>

                            </span> */}
                            {
                                this.props.contratos?.filter((contrato) => {
                                    return true
                                }).map(contrato => {
                                    console.log(contrato)
                                    return (
                                        <>
                                            <span className="entry-bookend-progress-container header interior" onClick={() => this.verificarFidelidade(contrato)}  >
                                                <div style={{width: "90%"}}>
                                                    <p className="nome-cliente">{contrato?.nomeassinante}</p>
                                                    <p className="endereco-cliente">{contrato?.endereco}</p>
                                                    <p className="endereco-cliente">{contrato?.nomecidade}</p>
                                                    <p className=""></p>
                                                    <p className="labels">
                                                        <span className="label-contrato">Contrato: {contrato?.numerocontrato}</span>
                                                        <span className="label-situacao">{contrato?.situacao}</span>
                                                    </p>
                                                    
                                                </div>
                                                <a className="botao-contrato" >
                                                    <FontAwesomeIcon className='fa-fw icone-resultado' size="lg"  icon={"chevron-right"} />
                                                </a>
                                            </span>
                                        </>
                                    )
                                })
                            }
                        </ul>
                        <div className='botoes-voltar'>
                            <Link to={"/selecionarcontrato/" + this.props.operacaoTotem.id} className="voltar-etapa" style={{ opacity: 0.5 }}  >
                                <FontAwesomeIcon className='fa-fw icone-resultado' size="lg"  icon={"chevron-left"} /> Voltar uma etapa
                            </Link>
                            <Link to={"/?idOperacaoTotem=" + this.props.operacaoTotem.id} onClick={()=> this.props.aoExpirar() } className="encerrar-etapa" >
                                <FontAwesomeIcon className='fa-fw icone-resultado' size="lg"  icon={"fa-arrow-right-from-bracket"}  flip="both" /> Encerrar Atendimento
                            </Link>                             
                        </div>
                    </span>
                </ul>
               <Modal visible={this.state.fidelidadeExpirandoVisivel} icon={"hands"} title={"Fidelização"} onClose={() => this.aoFecharFidelidade() } >
                    <p style={{fontSize: 'large', marginTop: 0, marginBottom: 0, width: "100%" }}>{this.props.operacaoTotem.mensagemRefidelizacao}</p><br/>
                    <a className="botao-pix botao-autoatendimento primario"  onClick={()=> this.consultarNumerosContrato()} style={{marginBottom: 20, marginTop: 20 }}>
                        <FontAwesomeIcon className='fa-fw icone-resultado' size="lg" icon={"fa-brands fa-whatsapp"}  /> Conhecer as Vantagens
                    </a>
                </Modal>
                <Modal visible={this.state.escolherNumeroVisivel} icon={"phone"} title={"Escolha o numero desejado: "} onClose={() => this.aoFecharTelefone() }>
                    <span className="circle progress-index larguinho" style={{marginBottom: 20}}>
                         <p style={{fontSize: 'large', margin: 10 }}>Escolha o número desejado para prosseguir:</p>
                         <ul id="progress-bar" className="entry-bookend-progress-container header lista-contratos" style={{ overflowY: "auto", alignItems:'flex-start'}}>
                            {
                                this.state.telefones.map(telefone => {
                                    return (
                                        <>
                                            <span className="entry-bookend-progress-container header interior" onClick={() => this.selecionarTelefone(telefone)} style={{height: 80}} >
                                                <div style={{width: "90%"}}>
                                                    <p className="nome-cliente">{telefone?.identificacaoofuscada}</p>
                                                </div>
                                                <a className="botao-contrato" >
                                                    <FontAwesomeIcon className='fa-fw icone-resultado' size="lg"  icon={"chevron-right"} />
                                                </a>
                                            </span>
                                        </>
                                    )
                                })
                            }                            
                            </ul>
                        </span>
                </Modal>
            </>
        )
    }
}
export default withRouter(SelecionarContrato);